/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Lines_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Lines" |
*
* @param {Audio_Description_Export_Subtitle_Max_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_lines_label = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre maximal de lignes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeilenanzahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linee massime")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество строк")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de líneas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大线路")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大行数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम रेखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de linhas")
	return /** @type {LocalizedString} */ ("Maximum Lines")
});